import React from "react";

const PRCard = ({releaseDate, title, link}) => {
  return (
    <div className="flex justify-between p-4 bg-white">
     <a href={link} target="_blank" rel="noopener noreferrer" className="hover:text-hmcHoverBlue">{title}</a>
     <time>{releaseDate}</time>
    </div>
  );
};

export default PRCard;
